import { Link } from "react-router-dom";
import type { Drama } from "@/mocks/dramas";

interface HeroSectionProps {
  drama: Drama;
}

export default function HeroSection({ drama }: HeroSectionProps) {
  return (
    <section className="relative h-[440px] w-full overflow-hidden md:h-[560px]">
      <img
        src={drama.banner}
        alt={`${drama.title}主视觉`}
        title={`${drama.title} 主视觉剧照`}
        className="absolute inset-0 h-full w-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/85 via-foreground-950/60 to-foreground-950/25" />

      <div className="relative z-10 mx-auto flex h-full w-full max-w-6xl flex-col justify-center px-4 md:px-6">
        <span className="mb-4 inline-flex w-fit items-center gap-1.5 rounded-full bg-primary-500 px-3 py-1 text-xs font-medium text-background-50">
          <i className="ri-fire-line" />
          旗舰剧集 · 热播中
        </span>
        <h1 className="font-heading text-4xl font-bold leading-tight text-background-50 md:text-6xl">
          {drama.title}
        </h1>
        <p className="mt-4 max-w-2xl text-sm leading-relaxed text-background-100 md:text-base">
          {drama.fullSynopsis.split("\n")[0]}
        </p>

        <div className="mt-5 flex flex-wrap items-center gap-x-6 gap-y-2 text-sm text-background-100/90">
          <span className="flex items-center gap-1.5">
            <i className="ri-star-fill text-accent-400" />
            <strong className="font-semibold text-background-50">
              {drama.rating}
            </strong>
            / 10
          </span>
          <span>{drama.year}</span>
          <span>{drama.genre}</span>
          <span>全 {drama.episodes} 集</span>
          <span>导演 {drama.director}</span>
        </div>

        <div className="mt-8 flex flex-wrap gap-3">
          <Link
            to={`/detail/${drama.id}`}
            className="inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-play-circle-line text-lg" />
            查看剧集详情
          </Link>
          <Link
            to={`/reviews/${drama.id}`}
            className="inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-background-50/60 bg-background-50/10 px-6 py-3 text-sm font-medium text-background-50 backdrop-blur transition-colors hover:bg-background-50/20"
          >
            <i className="ri-chat-quote-line text-lg" />
            看剧集点评
          </Link>
        </div>
      </div>
    </section>
  );
}